// Powitanie po zalogowaniu i po każdym odświeżeniu aplikacji: maskotka, nagłówek ręcznym pismem i „Zaczynamy!” (3 warianty, każdy kolejny pokaz bierze następny).
// Dopiero potem ekran główny z uruchomieniem lekcji (decyzja z makiet patcha-31).
// Napisy idą za przełącznikiem EN/PL (patch-33): „Let's go!” / „Zaczynamy!”, tytuł i tekst wariantu w obu językach.
import type { Pair } from '../lib/i18n.ts';
import { WELCOME_SCREENS } from '../lib/screens.ts';
import type { AppCtx } from './ctx.ts';
import { h } from './dom.ts';
import { tr, tx, txText } from './i18n.ts';
import { liveLang } from './i18nLive.ts';
import { icon, mascot } from './kit.ts';
import { renderLangCorner } from './langToggle.ts';

const T = {
  start: { en: "Let's go!", pl: 'Zaczynamy!' },
} as const satisfies Record<string, Pair>;

/** Tytuł z podkreśleniem pod ostatnim słowem (jak na makietach). */
export function underlined(title: string): (Node | string)[] {
  const i = title.lastIndexOf(' ');
  if (i < 0) return [h('span', { class: 'u' }, title)];
  return [`${title.slice(0, i)} `, h('span', { class: 'u' }, title.slice(i + 1))];
}

/** Nagłówek `<h1 class="hand-title">` z podkreślonym ostatnim słowem; po zmianie EN/PL układa się na nowo. */
export function underlinedTitle(ctx: AppCtx, title: Pair): HTMLElement {
  const el = h('h1', { class: 'hand-title' });
  const paint = (): void => el.replaceChildren(...underlined(tr(ctx, title)));
  paint();
  liveLang(ctx, el, paint);
  return el;
}

export function renderWelcome(ctx: AppCtx, onStart: () => void): void {
  const n = WELCOME_SCREENS.length;
  const i = ctx.variants ? ctx.variants.advance('welcome', n) : 0;
  const v = WELCOME_SCREENS[i % n]!;
  const go = h('button', { type: 'button', class: 'coral-btn', 'data-testid': 'welcome-start', onclick: () => {
    ctx.player.unlock(); // pierwszy gest użytkownika odblokowuje dźwięk na iOS
    onStart();
  } }, tx(ctx, T.start), icon('arrow'));
  ctx.root.replaceChildren(
    h('main', { class: 'stage start-screen welcome', 'data-testid': 'welcome', 'data-variant': i % n },
      renderLangCorner(ctx),
      mascot(v.pose),
      underlinedTitle(ctx, v.title),
      txText(ctx, h('p', { class: 'hand-text' }), v.text),
      go,
    ),
  );
}
